import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';

const FooterWrapper = styled.footer`
  background: var(--spruce-dark);
  padding: 70px 24px 36px;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 48px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 36px;
  }
`;

const BrandName = styled.p`
  font-family: 'Lora', serif;
  font-size: 1.2rem;
  font-weight: 600;
  color: #fff;
  margin: 0 0 10px;
`;

const Tagline = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 0.8rem;
  color: var(--text-light);
  line-height: 1.6;
  margin: 0 0 6px;
`;

const LocationText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  color: var(--text-light);
  margin: 0;
  opacity: 0.7;
`;

const ColumnHeading = styled.h4`
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: var(--sage-light);
  margin: 0 0 18px;
`;

const FooterLink = styled(Link)`
  text-decoration: none !important;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: var(--text-light);
  display: block;
  padding: 4px 0;
  transition: color 0.2s ease;

  &:hover {
    color: #fff;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;

  svg {
    color: var(--sage-light);
    flex-shrink: 0;
    font-size: 0.9rem;
  }
`;

const ContactText = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: var(--text-light);
`;

const BottomBar = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 20px;
  margin-top: 36px;
  text-align: center;
`;

const Copyright = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  color: var(--text-muted);
  margin: 0;
`;

const footerLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Who I Work With', path: '/who-i-work-with' },
  { label: 'Fees', path: '/fees' },
  { label: 'FAQs', path: '/faqs' },
  { label: 'Contact', path: '/contact' },
];

const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        <Grid>
          <div>
            <BrandName>Blue Spruce Therapy</BrandName>
            <Tagline>Trauma-Informed, Relationship-Focused Therapy</Tagline>
            <LocationText>Northern Vermont</LocationText>
          </div>

          <div>
            <ColumnHeading>Quick Links</ColumnHeading>
            {footerLinks.map((link) => (
              <FooterLink key={link.path} to={link.path}>
                {link.label}
              </FooterLink>
            ))}
          </div>

          <div>
            <ColumnHeading>Contact</ColumnHeading>
            <ContactItem>
              <FiPhone />
              <ContactText>(802) 255-8083</ContactText>
            </ContactItem>
            <ContactItem>
              <FiMail />
              <ContactText>audreykielylicsw@gmail.com</ContactText>
            </ContactItem>
            <ContactItem>
              <FiMapPin />
              <ContactText>Licensed in: VT, MA, CA, PA</ContactText>
            </ContactItem>
          </div>
        </Grid>

        <BottomBar>
          <Copyright>
            &copy; 2025 Blue Spruce Therapy. All rights reserved.
          </Copyright>
        </BottomBar>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;
